import { render } from "./RegisterEditBox.vue?vue&type=template&id=4ddd2d92&scoped=true&ts=true"
import script from "./RegisterEditBox.vue?vue&type=script&lang=ts"
export * from "./RegisterEditBox.vue?vue&type=script&lang=ts"

import "./RegisterEditBox.vue?vue&type=style&index=0&id=4ddd2d92&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddd2d92"]])

export default __exports__